import { Reducer } from 'redux';

import * as types from './settings.types';
import * as constants from './settings.constants';
import { isActionOfType } from '../../../utils/action.utils';

const initialState: types.ISettingsPageState = {
  isFetched: false,
};

const isFetchedReducer: Reducer<
  types.ISettingsPageState['isFetched'],
  types.IStoreIsFetched | types.IClearIsFetched
> = (state = initialState.isFetched, action) => {
  if (isActionOfType<types.IStoreIsFetched>(action, constants.STORE_IS_FETCHED)) {
    return true;
  } else if (isActionOfType<types.IClearIsFetched>(action, constants.CLEAR_IS_FETCHED)) {
    return initialState.isFetched;
  }
  return state;
};

export const settingsPageReducer: Reducer<types.ISettingsPageState, types.ISettingsPageAction> = (
  state = initialState,
  action,
) => {
  return {
    isFetched: isFetchedReducer(state.isFetched, action),
  };
};
